import { render, staticRenderFns } from "./trivia_list_page.vue?vue&type=template&id=fe9f9a5c&scoped=true"
import script from "./trivia_list_page.vue?vue&type=script&lang=js"
export * from "./trivia_list_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9f9a5c",
  null
  
)

export default component.exports